import { Box } from '@mui/material';
import { EqlField } from 'generated/graphql';
import { HTMLAttributes, ReactNode } from 'react';
import { AutoCompleteOption } from '../AutoCompleteOption';
import { FieldIcon } from '../FieldIcon';

interface EqlFieldsAutoCompleteOptionProps {
  props: HTMLAttributes<HTMLLIElement>;
  option: EqlField;
  inputValue: string;
  renderSecondaryAction?: (option: EqlField) => ReactNode;
  getOptionDisplayName: (option: EqlField) => string;
  renderTooltipTitle?: () => ReactNode;
}

export const EqlFieldsAutoCompleteOption = ({
  props,
  option,
  inputValue,
  renderSecondaryAction,
  getOptionDisplayName,
  renderTooltipTitle,
}: EqlFieldsAutoCompleteOptionProps) => {
  return (
    <AutoCompleteOption
      key={option.field}
      option={{
        id: option.field,
        displayName: getOptionDisplayName(option),
        creatorName: option.detail?.reference?.creatorName,
      }}
      baseProps={props}
      searchTerm={inputValue}
      renderLabelAvatar={() => (
        <Box sx={{ pr: 1 }}>
          <FieldIcon
            field={option.field}
            iconURL={option.iconURL}
            valueType={option.valueType}
            objectType={option.objectType}
          />
        </Box>
      )}
      renderSecondaryAction={
        renderSecondaryAction ? () => renderSecondaryAction(option) : undefined
      }
      renderTooltipTitle={renderTooltipTitle}
    />
  );
};
